<h2 mat-dialog-title class="title-small">Manage Deposit</h2>

<mat-dialog-content class="mat-typography" style="padding-top: 10px;">
    <div fxLayout="column" fxLayoutGap="16px">
        <div class="deposit-summary" fxLayout="column" fxLayoutGap="6px">
            <span class="body-1-regular-2">{{ data.name }}</span>
            <span class="footer-default">{{ data.email }}</span>
            <span class="deposit-amount">Available deposit: R {{ availableDeposit | number:'1.2-2' }}</span>
        </div>

        <div *ngIf="availableDeposit <= 0" class="deposit-warning">
            This user has no deposit available to deduct.
        </div>

        <form [formGroup]="form" fxLayout="column" fxLayoutGap="16px">
            <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always">
                <mat-label>Deduction amount</mat-label>
                <input matInput type="number" min="0.01" step="0.01" [max]="availableDeposit" formControlName="amount">
                <span matPrefix>R&nbsp;</span>
                <mat-error *ngIf="form.get('amount')?.hasError('required')">Amount is required.</mat-error>
                <mat-error *ngIf="form.get('amount')?.hasError('min')">Amount must be greater than zero.</mat-error>
                <mat-error *ngIf="form.get('amount')?.hasError('max')">Amount cannot exceed the available deposit.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="custom-text-field" floatLabel="always">
                <mat-label>Reason</mat-label>
                <textarea matInput rows="4" formControlName="reason" placeholder="Reason for the deposit deduction"></textarea>
                <mat-error *ngIf="form.get('reason')?.hasError('required')">Reason is required.</mat-error>
                <mat-error *ngIf="form.get('reason')?.hasError('maxlength')">Reason is too long.</mat-error>
            </mat-form-field>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" style="padding: 16px 24px;">
    <button mat-button (click)="onCancel()" class="body-1-regular-2">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid || availableDeposit <= 0">
        Deduct Deposit
    </button>
</mat-dialog-actions>
